import { Component, OnInit, OnDestroy, ViewChild  } from '@angular/core';
import { AlertService } from '../../servicios/alert.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Result } from '../../servicios/servers.service';
import { TipoServicioService } from '../../servicios/tiposervicio.service';
import { PersonaService } from '../../servicios/persona.service';
import { VehiculoService } from '../../servicios/vehiculo.service';
import swal from 'sweetalert2';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { EmpresaService } from '../../servicios/empresa.service';
import { BsModalComponent,BsModalService  } from 'ng2-bs3-modal';
import { setTimeout } from 'timers';
declare var jQuery: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'conductorReporte',
    templateUrl: 'conductorReporte.template.html'
})

// tslint:disable-next-line:component-class-suffix
export class ConductorReporte implements OnInit {

    constructor(
        private modalservice: BsModalService,
        private personaService: PersonaService,
        private alertService: AlertService,
        private tipoServicioService: TipoServicioService,
        private vehiculoService: VehiculoService,
        private empresaService: EmpresaService,
        private router: Router,
        private route: ActivatedRoute,
    ) {

    }

    @ViewChild('modal')
    public modal: BsModalComponent;
    public conductores = [];
    public sumServicios = 0;
    public sumConductores = 0;
    public fecha= {start: '', end: ''};

    ngOnInit() {
        let fecha = new Date();
        let mes:any = fecha.getMonth() + 1;
        if(mes<10){ mes = '0'+ mes} 
        this.fecha.start =  fecha.getFullYear() + "-" + mes + "-" + fecha.getDate();
        this.fecha.end =  fecha.getFullYear() + "-" + mes + "-" + fecha.getDate();
        this.getReporte();
        
    }
    
    getReporte() {
        loading_show();
        this.personaService.getConductoresServicioByFecha(this.fecha.start, this.fecha.end, (data: any) => {
            loading_hide();
            if (data.isOk) {

                this.conductores = data.Content;
                this.getTotal();

            }

        });
    }

    getTotal() {
        this.sumConductores = 0;
        this.sumServicios = 0;
        for(var i = 0; i < this.conductores.length; i++) {

            this.sumServicios += parseInt( this.conductores[i].cantidad );
            this.sumConductores++;

        }

        setTimeout(this.animateCounter, 500);

    }

    animateCounter() {
        jQuery('.counter').each(function () {
            var $this = jQuery(this),
                countTo = $this.attr('id');
            jQuery({ countNum: $this.text() }).animate({
                countNum: countTo
            },

                {

                    duration: 1000,
                    easing: 'linear',
                    step: function () {
                        $this.text(Math.floor(this.countNum));
                    },
                    complete: function () {
                        $this.text(new Intl.NumberFormat("CO").format(this.countNum));
                    }

                });
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/views/conductorReporte/conductorReporte.component.ts